import React, { Component } from 'react';
import {
  Image,
  ImageBackground,
  ScrollView,
  StyleSheet,
  Text,
  View,
  Platform,
} from 'react-native';

import GradientText from "react-native-gradient-texts";
import ResponsiveGradientText from '../components/ResponsiveGradientText';

import EonnButton from '../components/button';
import { mstyles } from '../constants/MainStyles';
import EonnStars from '../components/stars';

const styles = StyleSheet.create({
  infoContent: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    width: '100%',
    height: null,
    aspectRatio: 2.27,
    resizeMode: 'contain',
    marginBottom: 10,
  },
  logoContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: 20,
  },
  techProfileImage: {
    height: '45vw',
    width: '45vw',
    maxWidth: 200,
    maxHeight: 200,
    resizeMode: 'cover',
    borderRadius: '50%',
    borderWidth: 3,
    borderColor: '#fff',
    marginTop: 30,
    marginRight: 'auto',
    marginBottom: 0,
    marginLeft: 'auto',
  },
  title: {
    fontSize: 45,
    lineHeight: 45,
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: -20,
    marginLeft: 'auto',
    marginBottom: -6,
    marginRight: 'auto',
    paddingHorizontal: 20,
    textTransform: 'uppercase',
  },
  subtitle: {
    fontSize: 25,
    lineHeight: 25,
    fontWeight: 300,
    letterSpacing: 2,
    textAlign: 'center',
    marginTop: 0,
    marginRight: 'auto',
    marginBottom: 20,
    marginLeft: 'auto',
    paddingTop: 12,
    paddingHorizontal: 20,
    borderTopWidth: 2,
    borderColor: '#f0958a',
    display: 'inline-block',
    width: 'auto',
  },
  sContent: {
    paddingTop: 0,
    paddingBottom: 30,
    paddingHorizontal: 20,
    flexDirection: 'column',
    width: '100%',
    maxWidth: 650,
    marginLeft: 'auto',
    marginRight: 'auto',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  rate: {
    fontSize: 21,
    lineHeight: 27,
    marginRight: 5,
    textAlign: 'center',
    marginTop: 10,
    marginRight: 'auto',
    marginBottom: 10,
    marginLeft: 'auto',
    paddingHorizontal: 20,
    maxWidth: 450,
  },
  about: {
    fontSize: 18,
    marginTop: 10,
    marginBottom: 20,
    textAlign: 'center',
    borderTopWidth: 1,
    paddingTop: 35,
    paddingHorizontal: 20,
    borderColor: '#c6c8d4',
    maxWidth: 550,
  },
  reviewsContainer: {
    width: '100%',
    maxWidth: 800,
    marginTop: 0,
    paddingHorizontal: 20,
  },
  reviewsHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  reviewsHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  reviewsTitle: {
    fontSize: 23,
    marginLeft: 20,
  },
  reviewCard: {
    backgroundColor: 'rgba(255,255,255,0.9)',
    borderRadius: 8,
    padding: 12,
    marginBottom: 10,
    marginLeft: 20,
  },
  reviewMeta: {
    fontSize: 14,
    color: '#666',
    marginBottom: 4,
    marginLeft: 0,
  },
  reviewText: {
    fontSize: 16,
    color: '#242632',
    marginTop: 10,
    marginBottom: 10,
    marginLeft: 0,
  },
});

export default class C_TechInfo extends Component {

  render() {
    const hasTechLink = !!global.techLink;

    return (
      <ScrollView style={mstyles.sContainer} contentContainerStyle={mstyles.sContent}>
        <ImageBackground
          source={require('../assets/images/bg4.jpg')}
          style={styles.sContent}
          imageStyle={{ resizeMode: 'cover' }}
        >
          {hasTechLink && global.techLinkBid ? (
            <View style={styles.infoContent}>

              {global.techLinkBid.t_profilePicture ? (
                <Image
                  source={{ uri: global.techLinkBid.t_profilePicture }}
                  style={styles.techProfileImage}
                />
              ) : (
                <Image
                  source={require('../assets/images/portrait1.png')}
                  style={styles.techProfileImage}
                />
              )}

              <ResponsiveGradientText
                text={global.techLinkBid.t_bname || global.techLinkBid.t_name || 'Auto Tech Business Name'}
                style={[styles.title]}
                gradientColors={["#464853", "#6b6e7d"]}
                fontFamily={"nunito"}
                fontWeight={900}
              />
              <Text style={[mstyles.mfont, styles.subtitle]}>
                VIDEO CONSULTATIONS
              </Text>

              <Text style={[mstyles.mfont, styles.rate]}>
                Need car help? Start a video chat and get expert advice for just <Text style={{ fontWeight: 'bold' }}>${global.techLinkBid.price}</Text>.
              </Text>

              <EonnButton
                onPress={() => this.props.navigation.navigate('C_Profile1')}
              >
                Start Video Chat
              </EonnButton>

              <Text style={[mstyles.text, mstyles.center, styles.about]}>
                {global.techLinkBid.t_about}
              </Text>
            </View>
          ) : (
            <View style={styles.infoContent}>
              <View style={styles.logoContainer}>
                <Image
                  source={'../assets/images/intro-logo.png'}
                  style={styles.logo}
                />
              </View>
              <Text style={[mstyles.mfont, styles.title]}>Online vehicle diagnosis</Text>

              <EonnButton
                onPress={() => this.props.navigation.navigate('C_Profile1')}
              >
                Start Video Chat
              </EonnButton>
            </View>
          )}

        </ImageBackground>
        {hasTechLink && (
          <View style={styles.reviewsContainer}>
            <View style={styles.reviewsHeaderRow}>
              <View style={styles.reviewsHeaderLeft}>
                <Text style={[mstyles.mfont, styles.reviewsTitle]}>Customer Reviews</Text>
              </View>
            </View>
            {(Array.isArray(global.techLinkBid?.t_review) ? [...global.techLinkBid.t_review] : [])
              .sort((a,b) => new Date(b.date || 0) - new Date(a.date || 0))
              .slice(0, 10)
              .map((r, idx) => (
                <View key={idx} style={styles.reviewCard}>
                  <Text style={[mstyles.text, styles.reviewMeta]}>
                    {(r.customerName || 'Anonymous')}{r.date ? ` · ${new Date(r.date).toLocaleDateString()}` : ''}
                  </Text>
                  {Number.isFinite(Number(r.rating)) && Number(r.rating) > 0 && (
                    <EonnStars stars={Math.round(Math.max(1, Math.min(5, Number(r.rating))))} />
                  )}
                  <Text style={[mstyles.text, styles.reviewText]}>
                    {r.review || ''}
                  </Text>
                </View>
            ))}
          </View>
        )}
      </ScrollView>
    );
  }
}


